<!-- Overlay -->
<div class="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50" (click)="closePopup()">
    <div class="relative rounded-lg overflow-hidden max-w-3xl max-h-full w-full p-4" (click)="$event.stopPropagation()">
      
      <button 
        class="absolute top-4 right-4 text-2xl text-gray-800 hover:text-red-600 transition"
        (click)="closePopup()"><ui-icon [icon]="EIcon.Close" [size]="EComponentSize.Medium" [color]="EAlert.LIGHT"></ui-icon>
      </button>
  
      <img [src]="imageUrl()" alt="Imagem" class="max-w-full max-h-[80vh] object-contain" />
    </div>
  </div>
  